module.exports = __webpack_public_path__ + "static/media/captivating-thumbnail.2685664b.png";